// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Roboto_10f679', '__Roboto_Fallback_10f679'","fontWeight":400,"fontStyle":"normal"},"className":"__className_10f679"};